import { render } from "./LogPanel.vue?vue&type=template&id=252bb955&ts=true"
import script from "./LogPanel.vue?vue&type=script&lang=ts"
export * from "./LogPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__